"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class OffchainSolidexHelper {
    constructor(offchain) {
        this.offchain = offchain;
    }
    cleanCache() {
        this.solidexLPDetails = null;
    }
    initializeSolidexLPDetails() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch("https://api.solidexfinance.com/api/getLPDetails?v=fantom");
                if (response.status != 200)
                    return {};
                const data = yield response.json();
                if (!data || !data.success)
                    return {};
                const solidexLPDetails = {};
                for (const pool of data.data.poolDetailsAll) {
                    if (!pool.solidexTVL)
                        continue;
                    solidexLPDetails[pool.poolAddress.toLowerCase()] = [
                        {
                            APR: pool.solidexTVL.realsolidAPR / 100,
                            symbol: "SOLID",
                        },
                        {
                            APR: pool.solidexTVL.realsexAPR / 100,
                            symbol: "SEX",
                        },
                    ];
                }
                return solidexLPDetails;
            }
            catch (e) {
                return {};
            }
        });
    }
    getSolidexLPDetails() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.solidexLPDetails)
                this.solidexLPDetails = this.initializeSolidexLPDetails();
            return this.solidexLPDetails;
        });
    }
}
exports.default = OffchainSolidexHelper;
